import { api } from "@/lib/api";

/** Convert base64url VAPID key to Uint8Array for PushManager.subscribe() */
function urlBase64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function pushPermission() {
  if (!pushSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function getPushSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return await reg.pushManager.getSubscription();
}

/** Ask permission, subscribe with VAPID, register on backend. Returns true on success. */
export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Tento prehliadač nepodporuje push notifikácie.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Povolenie zamietnuté.");

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();

  if (!sub) {
    const { data } = await api.get("/push/vapid-public-key");
    const appServerKey = urlBase64ToUint8Array(data.public_key);
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: appServerKey,
    });
  }

  await api.post("/push/subscribe", {
    subscription: sub.toJSON(),
    user_agent: navigator.userAgent,
  });
  return true;
}

/** Best-effort unsubscribe (server + browser). */
export async function unsubscribeFromPush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try {
    await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
  } catch (_) {}
  try { await sub.unsubscribe(); } catch (_) {}
}

export async function sendTestPush() {
  await api.post("/push/test");
}

/** Clear PWA app-icon badge when user opens the chat. */
export function clearAppBadge() {
  if ("clearAppBadge" in navigator) {
    navigator.clearAppBadge().catch(() => {});
  }
}
